import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Checkbox, Form, Spin } from "antd";
import { InputNumberField } from "../../../../../../atoms/FormFields";
import { useForm } from "react-hook-form";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  title: string;
  heading: string;
  paragraph?: string | JSX.Element;
  btnText: string;
  btnApi: () => void;
  loading: boolean;
  secondBtnText?: string;
  isArchivePopup?: boolean;
}

interface FormValues {
  proposal_amount_exceeds: string;
}

const ApprovalAndChangeOrderPopup = (props: PropsType) => {
  const { onClose, heading, paragraph, btnText, btnApi, loading } = props;

  const onCloseHandler = () => {
    onClose();
  };

  const { control, handleSubmit } = useForm<FormValues>();
  const onSubmit = (data: FormValues) => {
    console.log("Form Data:", data);
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper">
        <Form
          layout="vertical"
          onFinish={handleSubmit(onSubmit)}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.preventDefault();
          }}
        >
          <div className="modal_header">
            <div className="title" style={{ textAlign: "center" }}>
              <h3 style={{ marginBottom: "12px" }}> {heading} </h3>
            </div>
          </div>

          <div className="modal_content">
            <p
              style={{
                color: "#474C4D",
                marginBottom: "32px",
                fontSize: "16px",
                lineHeight: "24px",
              }}
            >
              {paragraph}
            </p>

            <div
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                justifyContent: "flex-start",
                marginBottom: "4px",
              }}
            >
              <Checkbox /> Proposal amount exceeds
              <InputNumberField
                fieldName="proposal_amount_exceeds"
                label=""
                control={control}
                iProps={{
                  placeholder: "$ 0.00",
                  min: 1,
                }}
                className="mb_0"
              />
            </div>

            <div
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                justifyContent: "flex-start",
                marginBottom: "4px",
              }}
            >
              <Checkbox /> Gross margin is below company target
            </div>
          </div>

          <div
            className="modal_footer"
            style={{
              margin: "0 auto",
              paddingTop: "32px",
              justifyContent: "center",
            }}
          >
            <Button
              htmlType="button"
              className="outlined-btn"
              type="default"
              size="large"
              onClick={onCloseHandler}
            >
              Cancel
            </Button>

            <Button
              htmlType="button"
              className="mint-btn"
              type="primary"
              size="large"
              onClick={btnApi}
              loading={loading}
            >
              {btnText}
            </Button>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default ApprovalAndChangeOrderPopup;
